import { Box, SxProps } from "@mui/material";
import { CSSProperties } from "react";
import { useTranslation } from "react-i18next";
import Logo from "../../../assets/images/lazo-logo.png";
import StarIconSvg from "../../../assets/images/star-logo.svg";

interface Props {
  containerSxProps: SxProps;
  imageWidth: string | number;
  imgStyle?: CSSProperties;
  includeStar?: boolean;
}

export const LazoLogo = ({ containerSxProps, imageWidth, imgStyle, includeStar }: Props) => {
  const { t } = useTranslation("common");

  return (
    <Box sx={containerSxProps}>
      <img style={imgStyle} src={Logo.src} alt={t("alt.lazoLogo")} width={imageWidth} /> {includeStar && <img src={StarIconSvg.src} />}
    </Box>
  );
};
